var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sections",class:_vm.sections.length > 8 && 'long'},_vm._l((_vm.sections),function(section){return _c('Section',{key:section.id,attrs:{"section":section}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }